import React from 'react';
import LoginPage from './LoginPage';
import OAuthLoginPage from './OAuthLoginPage';
import LogoutPage from './LogoutPage';
import SignUpPage from './SignUpPage';
import PostSignupPage from './PostSignupPage';
import ActivatePage from './ActivatePage';
import PasswordRecoveryPage from './PasswordRecoveryPage';
import PasswordResetPage from './PasswordResetPage';
import PasswordConfirmationPage from './PasswordConfirmationPage';
import ProviderSignupPage from './ProviderSignupPage';
import ProviderSignupPage2 from './ProviderSignupPage2';  // eventually rename to replace ProviderSignupPage
import ProvidersProfilePage from './ProviderProfilePage';
import ProviderActivatePage from './ProviderActivatePage';
import ProviderLoginPage from './ProviderLoginPage';
import ProviderCallbackPage from './ProviderCallbackPage';
import ProviderInvitePage from './ProviderInvitePage';
import ProviderClaimProfilePage from './ProviderClaimProfilePage';
import ProviderClaimProfilePage2 from './ProviderClaimProfilePage2';
import OAuthActivatePage from './OAuthActivatePage';
import ActivationSwitch from './components/ActivationSwitch';
import { Route } from 'react-router-dom';

// modules return fragments containing routes.

const participant = (Component) => (props) => <Component isProvider={false}  {...props}/>;
const provider = (Component) => (props) => <Component isProvider={true} {...props}/>;

const routes = () => {
  return [
    // participant only
    <Route key="/login" exact path="/login" component={LoginPage}/>,
    <Route key="/oauth/login" exact path="/oauth/login" component={OAuthLoginPage}/>,

    <Route key="/signup" exact path="/signup" component={SignUpPage}/>,
    <Route key="/activate" exact path="/activate" component={ActivatePage}/>,
    <Route key="/password/recover" exact path="/password/recover" component={participant(PasswordRecoveryPage)}/>,
    <Route key="/password/confirm" exact path="/password/confirm" component={PasswordConfirmationPage}/>,
    <Route key="/password/reset" exact path="/password/reset" component={participant(PasswordResetPage)}/>,
    // <Route key="/profile" exact path="/profile" component={ProfilePage}/>,
    // provider only
    <Route key="/providers/login" exact path="/providers/login" component={ProviderLoginPage}/>,
    <Route key="/providers/signup" exact path="/providers/signup" component={ProviderSignupPage}/>,
    <Route key="/providers/signup2" exact path="/providers/signup2" component={ProviderSignupPage2}/>,
    <Route key="/providers/claimprofile" exact path="/providers/claimprofile/:uuid" component={ProviderClaimProfilePage}/>,
    <Route key="/providers/claimprofile2" exact path="/providers/claimprofile2/:uuid" component={ProviderClaimProfilePage2}/>,
    <Route key="/providers/activate" exact path="/providers/activate" component={ProviderActivatePage}/>,
    <Route key="/providers/password/recover" exact path="/providers/password/recover" component={provider(PasswordRecoveryPage)}/>,
    <Route key="/providers/password/confirm" exact path="/providers/password/confirm" component={PasswordConfirmationPage}/>,
    <Route key="/providers/password/reset" exact path="/providers/password/reset" component={provider(PasswordResetPage)}/>,
    <Route key="/providers/profile" exact path="/providers/profile" component={ProvidersProfilePage}/>,
    <Route key="/providers/invite" exact path="/providers/invite" component={ProviderInvitePage}/>,
    // callback isn't currently used, will be used for OAuth signin
    <Route key="/providerauth/callback" exact path="/providerauth/callback" component={ProviderCallbackPage}/>,
    // shared between participant and provider
    <Route key="/signup/confirm" exact path="/signup/confirm" component={PostSignupPage}/>,
    <Route key="/logout" exact path="/logout" component={LogoutPage}/>,
  ];
};

export default routes;

export const ActivationRoute = (subroutes) =>
  <Route key="activation" render={()=><ActivationSwitch routes={subroutes} render={()=><OAuthActivatePage/>}/>}/>;
